<template>
    <div>
        <div class="home-right-bar">
            <ul class="right-bar-list">
                <li class="li-f0">
                    <div class="my-qb first-title" @click="goUserinfo">
                        <img  src="../assets/images/nav_qb_icon_1.png" class="icon-info-1">
                        <img  src="../assets/images/nav_qb_icon_2.png" class="icon-info-2">
                        <p>我的青邦</p>
                    </div>
                </li>
                <li class="li-f0" >
                    <div class="first-title">
                        <img  src="../assets/images/nav_dd_icon_1.png" class="icon-info-1">
                        <img  src="../assets/images/nav_dd_icon_2.png" class="icon-info-2">
<!--                        <i class="iconfont iconfont-info icon-dingdan"></i>-->
                        <p>我的订单</p>
                    </div>
                    <div class="bar-children order-list-children order-code-bg" >
                        <div class="img-bg special-margin">
                            <ul>
                                <li v-for="(item,index) in orderList" :key="index" @click="goToOrderList(item.type)">
                                    <img :src="item.orderIcon1" class="order-icon order-icon-1">
                                    <img :src="item.orderIcon2" class="order-icon order-icon-2">
                                    <span>{{item.name}}</span>
                                </li>
                            </ul>
                        </div>

                    </div>
                </li>
                <li class="li-f0" >
                    <div class="first-title" @click="goShopCart">
                        <img  src="../assets/images/nav_cgc_icon_1.png" class="icon-info-1">
                        <img  src="../assets/images/nav_cgc_icon_2.png" class="icon-info-2">
<!--                        <i class="iconfont iconfont-info icon-gouwuche1"></i>-->
                        <p>采购车</p>
                    </div>
                </li>
                <li class="li-f0">
                    <div class="first-title" @click="IMInfo">
                        <img  src="../assets/images/nav_im_icon_1.png" class="icon-info-1">
                        <img  src="../assets/images/nav_im_icon_2.png" class="icon-info-2">
<!--                        <i class="iconfont iconfont-special icon-huihua"></i>-->
                        <p>在线客服</p>
                    </div>
                </li>
                <li class="li-f0">
                    <div class="first-title">
                        <img  src="../assets/images/nav_dh_icon_1.png" class="icon-info-1">
                        <img  src="../assets/images/nav_dh_icon_2.png" class="icon-info-2">
<!--                        <i class="iconfont iconfont-special icon-dianhua"></i>-->
                        <p>客服电话</p>
                    </div>
                    <div class="bar-children phone-code-bg">
                        <div class="img-bg mr15">
                            <div class="fl">
                                <img src="../assets/images/nav_phone_icon.png" class="service-phone">
                            </div>
                            <ul class="fl">
                                <li>0571-87221111</li>
                                <li>0551-69127696</li>
                            </ul>
                            <div class="clearb"></div>
                        </div>
                    </div>
                </li>
                <li class="li-f0">
                    <div class="first-title">
                        <img  src="../assets/images/nav_ewm_icon_1.png" class="icon-info-1">
                        <img  src="../assets/images/nav_ewm_icon_2.png" class="icon-info-2">
<!--                        <i class="iconfont iconfont-special icon-erweima"></i>-->
                        <p>下载码</p>
                    </div>
                    <div class="bar-children QR-code-bg">
                        <div class="img-bg QR-info">
                            <div class="fl QR-item QR-item-right" style="width: 75px">
                                <img src="../assets/images/app_big.png">
                                <p>APP下载码</p>
                            </div>
                            <div class="fl QR-item" style="width: 105px;">
                                <img src="../assets/images/weixin_big.png">
                                <p>青邦企服公众号</p>
                            </div>
                            <div class="clearb"></div>
                        </div>
                    </div>
                </li>
                <li class="li-f0 li-backTop">
                    <div @click="backToTop" class="first-title">
                        <img  src="../assets/images/nav_top_icon_1.png" class="icon-info-1">
                        <img  src="../assets/images/nav_top_icon_2.png" class="icon-info-2">
<!--                        <i class="iconfont iconfont-info icon-huidaodingbu"></i>-->
                        <p>回到顶部</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        name: "rightBar",
        data(){
            return{
                orderList:[
                    {
                        orderIcon1:require('@/assets/images/home/nav_icon_1.png'),
                        orderIcon2:require('@/assets/images/home/home_nav_icon_1.png'),
                        name:'办公采购',
                        type:'CG'
                    },
                    {
                        orderIcon1:require('@/assets/images/home/nav_icon_2.png'),
                        orderIcon2:require('@/assets/images/home/home_nav_icon_2.png'),
                        name:'工商财税',
                        type:'CS'
                    },
                    {
                        orderIcon1:require('@/assets/images/home/nav_icon_3.png'),
                        orderIcon2:require('@/assets/images/home/home_nav_icon_3.png'),
                        name:'办公装修',
                        type:'ZX'
                    },
                    {
                        orderIcon1:require('@/assets/images/home/nav_icon_4.png'),
                        orderIcon2:require('@/assets/images/home/home_nav_icon_4.png'),
                        name:'商标注册',
                        type:'YD'
                    },
                    {
                        orderIcon1:require('@/assets/images/home/nav_icon_5.png'),
                        orderIcon2:require('@/assets/images/home/home_nav_icon_5.png'),
                        name:'人才服务',
                        type:'FW'
                    },
                    {
                        orderIcon1:require('@/assets/images/home/nav_icon_6.png'),
                        orderIcon2:require('@/assets/images/home/home_nav_icon_6.png'),
                        name:'会议室预订',
                        type:'HY'
                    }
                ]
            }
        },
        mounted() {
        },
        methods:{
            backToTop(){
                document.documentElement.scrollTop = document.body.scrollTop = 0;
            },
            goToOrderList(type){
                this.$router.push('/orderlist?t='+type);
            },
            goUserinfo(){
                this.$router.push({ path: 'centerinfo'});
            },
            goShopCart(){
                this.$router.push({ path: 'shopcart'});
            },
            IMInfo(){
                window.open( 'http://47.98.229.144:8035/im/text/00wjy4.html');
            }
        }
    }
</script>

<style scoped>
    .home-right-bar{
        position: fixed;
        bottom: 10px;
        /*right: 250px;*/
        left: 90%;
        border:1px solid rgba(240,240,240,1);
        border-radius:10px;
        width: 70px;
        z-index: 99;
        background: white;
    }
    .right-bar-list{
        padding: 5px 5px;
    }
    .right-bar-list .li-f0{
        text-align: center;
        border-bottom:1px solid #F0F0F0;
        padding: 5px 0;
        font-size: 10px;
        cursor: pointer;
    }
    .right-bar-list li p{
        margin-top: 1px;
        color: #666666;
        font-weight: 400;
        white-space: nowrap;
    }
    .my-qb img{
        width: 20px;
        height: 20px;
    }
    .icon-info-1{
        display: inline-block;
    }
    .icon-info-2{
        display: none;
    }
    .first-title:hover .icon-info-1{
        display: none;
    }
    .first-title:hover .icon-info-2{
        display: inline-block;
    }

    .right-bar-list .iconfont-info{
        font-size: 26px;
    }
    .iconfont-special{
        font-size: 21px;
    }
    .bar-children{

        /*width: 168px;*/
        position: absolute;
        display: none;
    }
    .img-bg{
        background: url("../assets/images/nav_ewm_bg.png");
        background-size: 100% 100%;

    }
    .special-margin{
        background: url("../assets/images/nav_dd_bg.png");
        background-size: 100% 100%;
        margin: 10px;
    }
    .bar-children li{
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 16px;
        color: #333;
    }
    .order-list-children li{
        text-align: left;
        padding-left: 10px;
        width: 85%;
        margin: 0 auto;
        white-space: nowrap;
    }
    .li-backTop{
        border-bottom: none!important;
    }
    .order-code-bg{
        width: 168px;
        left: -164px;
        top: -75px;
    }
    .order-icon{
        margin-bottom: -5px;
        margin-right: 8px;
    }
    .order-icon-1{
        display: inline-block;
    }
    .order-icon-2{
        display: none;
    }
    .order-code-bg li:hover{
        color: #69AB13;
    }
    .order-code-bg li:hover .order-icon-1{
        display: none;
    }
    .order-code-bg li:hover .order-icon-2{
        display: inline-block;
    }
    .phone-code-bg{
        width: 219px;
        top: 180px;
        left: -208px;
    }
    .service-phone{
        margin-top: 27px;
        margin-right: 10px;
        margin-left: 15px;
    }
    .QR-code-bg{
        width: 230px;
        left: -223px;
        bottom: 9px;
        padding: 15px;
    }
    .QR-info{
        width: 205px;
    }
    .QR-item img{
        width: 75px;
    }
    .QR-item{
        text-align: center;
        margin: 5px;
    }
    .QR-item p{
        height: 15px;
        line-height: 1;
        font-size: 12px;
    }
    .li-f0:hover .first-title p{
        color: #69AB13;
    }
    .phone-code-bg li{
        color: #69AB13;
    }
    .li-f0:hover .bar-children{
        display: block;
    }


</style>



// WEBPACK FOOTER //
// src/components/rightBar.vue